import React from 'react';
import AdminConferenceDashboard from '@/components/Admin/CallDashboardContainer/Conference';
import { DocumentsStyles } from '../styles/DocumentsStyled';

const Conference = () => {
    return (
        <div css={DocumentsStyles}>
            <h1 className="mb-4">Conference</h1>
            <AdminConferenceDashboard />
        </div>
    );
};

export default Conference;
